export default __webpack_public_path__ + "static/media/stylehelp.54347376.png";